import {
	CHANNEL_NAMES,
	Channel,
	ChannelsSelectOption,
} from "interfaces/channels";

export const getChannelName = (channel: CHANNEL_NAMES): Channel | string => {
	switch (channel) {
		case CHANNEL_NAMES.AIRBNB_OFFICIAL:
			return Channel.AIRBNB_OFFICIAL;
		case CHANNEL_NAMES.AIRBNB:
			return Channel.AIRBNB;
		case CHANNEL_NAMES.BOOKING:
			return Channel.BOOCKINGCOM;
		case CHANNEL_NAMES.DIRECT:
			return Channel.DIRECT;
		case CHANNEL_NAMES.VRBO:
			return Channel.VRBO;
		case CHANNEL_NAMES.MANUAL:
			return Channel.MANUAL;
		default:
			return "";
	}
};

// Canonical channel filter options used by every channel filter UI
// (Reservations, Dashboard, Guests, etc.). Order is fixed.
export const channelsList: Array<ChannelsSelectOption> = [
	{ value: CHANNEL_NAMES.AIRBNB, label: "Airbnb" },
	{ value: CHANNEL_NAMES.BOOKING, label: "Booking.com" },
	{ value: CHANNEL_NAMES.VRBO, label: "Vrbo" },
	{ value: CHANNEL_NAMES.DIRECT, label: "Direct" },
	{ value: CHANNEL_NAMES.MANUAL, label: "Manual" },
];

// The Hospitable API returns several spellings per channel — Channel enum
// uses "bookingcom"/"vrbo" while CHANNEL_NAMES (our canonical filter ids)
// use "booking"/"homeaway". Map each canonical filter value to every raw
// value that should match it so filtering stays robust no matter which
// endpoint produced the reservation.
// Keys are constrained to CHANNEL_NAMES so a typo in a canonical id fails at
// compile time; values stay as `string[]` because raw API spellings (e.g.
// "bookingcom", "booking.com", "vrbo") aren't CHANNEL_NAMES members.
const CHANNEL_ALIASES: Partial<Record<CHANNEL_NAMES, string[]>> = {
	[CHANNEL_NAMES.AIRBNB]: [CHANNEL_NAMES.AIRBNB, CHANNEL_NAMES.AIRBNB_OFFICIAL],
	[CHANNEL_NAMES.BOOKING]: [CHANNEL_NAMES.BOOKING, "bookingcom", "booking.com"],
	[CHANNEL_NAMES.VRBO]: [CHANNEL_NAMES.VRBO, "vrbo"],
};

export const matchesChannelFilter = (
	itemChannel: string | undefined,
	filterValue: string,
): boolean => {
	if (!itemChannel) return false;
	const itemLower = itemChannel.toLowerCase();
	const aliases = CHANNEL_ALIASES[filterValue as CHANNEL_NAMES];
	if (aliases) return aliases.includes(itemLower);
	return itemLower === filterValue.toLowerCase();
};

// Expand selected channel ids into the full set of channel values the backend
// recognises. Currently only "airbnb" maps to both "airbnb" and "airbnb-official".
export const expandChannelsForBackend = (channels: string[]): string[] => {
	const out: string[] = [];
	channels.forEach((id) => {
		out.push(id);
		if (id === CHANNEL_NAMES.AIRBNB) out.push(CHANNEL_NAMES.AIRBNB_OFFICIAL);
	});
	return out;
};
